import type { StateCreator } from 'zustand';
import type { AddressStore } from '../../../stores/address/address-store';
import { AddressBookAction } from './address-book-slice.types';
import type { AddressBookSlice } from './address-book-slice.types';

const initialAddressBookState = {
  savedContacts: [],
};

export const createAddressBookSlice: StateCreator<AddressStore, [['zustand/devtools', never]], [], AddressBookSlice> = (
  set,
) => ({
  ...initialAddressBookState,

  setSavedContacts: (contacts) => set({ savedContacts: contacts ?? [] }, false, AddressBookAction.SetSavedContacts),
});
